module.exports = __webpack_public_path__ + "img/RoomBroadcastNotification.cb10b51.png";